__turbopack_context__.v({
  "expandable_toggle_button": "hQnANG_expandable_toggle_button",
  "expanded": "hQnANG_expanded",
});
